import dayjs from 'dayjs';

import { OneTimePassFormData } from '@/contexts/forms/OneTimePass';
import { CustomSessionStorage } from '@/lib/storage/customSessionStorage';

const KEY_ONE_TIME_FORM_DATA = 'one-time-form-data';
const KEY_ONE_TIME_CERT_EXPIRY = 'one-time-cert-expiry';

export const oneTimePassFormDataSessionStorage =
  CustomSessionStorage<OneTimePassFormData>(KEY_ONE_TIME_FORM_DATA + '-sms');

export const mailOneTimePassFormDataSessionStorage =
  CustomSessionStorage<OneTimePassFormData>(KEY_ONE_TIME_FORM_DATA + '-mail');

/** ワンタイム認証有効期限 (ペイペイ口座連携) */
export const otpSendPaypayCertExpiryStorage = CustomSessionStorage<string>(
  `${KEY_ONE_TIME_CERT_EXPIRY}`,
);

export const isOtpValidSendPaypay = () => {
  const expiryString = otpSendPaypayCertExpiryStorage.get();
  const expiry = dayjs(expiryString);
  if (expiry) {
    if (dayjs() < expiry) {
      return true;
    }
  }
  return false;
};
